import { Injectable } from '@angular/core';
import { Storage } from '@ionic/storage';
import { Observable } from 'rxjs/Observable';

@Injectable()
export class IonicStorageProvider {
	constructor(private storage: Storage) {}

	setAuthToken(token: string): Promise<any> {
		return this.storage.set('authToken', token);
	}

	setRefreshToken(token: string): Promise<any> {
		return this.storage.set('refreshToken', token);
	}

	getAuthToken(): Observable<any> {
		if (this.storage === undefined) {
			return Observable.throw(new Error("Storage isn't created"));
		}
		return Observable.fromPromise(this.storage.get('authToken'));
	}

	getRefreshToken(): Observable<any> {
		if (this.storage === undefined) {
			return Observable.throw(new Error("Storage isn't created"));
		}
		return Observable.fromPromise(this.storage.get('refreshToken'));
	}

	removeTokens(): void {
		this.storage.remove('authToken');
		this.storage.remove('refreshToken');
	}
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/string-replace-webpack-plugin/loader.js?id=kkml25e9zf!./mobile/src/providers/ionic-storage/storage.service.ts